module.exports = __webpack_public_path__ + "img/heart_11_bj.586a0393.png";